import { render, staticRenderFns } from "./styleInstance2.vue?vue&type=template&id=7832f640&scoped=true"
import script from "./styleInstance2.vue?vue&type=script&lang=js"
export * from "./styleInstance2.vue?vue&type=script&lang=js"
import style0 from "./styleInstance2.vue?vue&type=style&index=0&id=7832f640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7832f640",
  null
  
)

export default component.exports